import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Courses', href: '/courses' },
    { name: 'About', href: '/about' },
    { name: 'Gallery', href: '/gallery' },
    { name: 'Testimonials', href: '/testimonials' },
    { name: 'FAQ', href: '/faq' },
    { name: 'Contact', href: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      {/* Top bar with contact info */}
      <div className="bg-[#1e3a8a] text-white py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-0 text-sm">
            <div className="flex items-center gap-4 sm:gap-6">
              <a href="tel:+919914637377" className="flex items-center gap-2 hover:text-gray-200 transition-colors">
                <Phone className="h-4 w-4" />
                <span>+91 9914637377</span>
              </a>
              <a href="mailto:enquiries@overseasdentalachievers.co.in" className="flex items-center gap-2 hover:text-gray-200 transition-colors">
                <Mail className="h-4 w-4" />
                <span>enquiries@overseasdentalachievers.co.in</span>
              </a>
            </div>
            <div className="text-xs sm:text-sm">
              SCO 224-225, Sector 40D, Chandigarh
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_oda-courses/artifacts/q8rv8hyg_ODA%20LOGO%20-%20Copy.jpeg" 
              alt="ODA - Overseas Dental Achievers" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors hover:text-[#1e3a8a] ${
                  isActive(item.href)
                    ? 'text-[#1e3a8a] border-b-2 border-[#1e3a8a] pb-1'
                    : 'text-gray-700'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Button asChild className="bg-[#1e3a8a] hover:bg-[#1e3a8a]/90">
              <Link to="/contact">Enquire Now</Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            type="button"
            className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col gap-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-base font-medium transition-colors hover:text-[#1e3a8a] ${
                    isActive(item.href) ? 'text-[#1e3a8a]' : 'text-gray-700'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Button asChild className="bg-[#1e3a8a] hover:bg-[#1e3a8a]/90 w-full">
                <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
                  Enquire Now
                </Link>
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
